import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthPage from "./AirSearch/AuthPage";
import Index from "./AirSearch/Index";
import AboutUs from "./AirSearch/About";
const styles = `
*{
  margin:0;
  padding:0;
  box-sizing:border-box;
  font-family:Arial, sans-serif;
}

body{
  background:#fff;
}

/* Navbar */
.tc-nav{
  height:85px;
  background:rgb(255, 255, 255);
  border-bottom:1px solid #dcdcdc;
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:0 35px;
  position:sticky;
  top:0;
  z-index:100;
}

/* Logo */
.tc-brand img{
  height:100px;
  object-fit:contain;
}

/* Center Nav */
.tc-nav-links{
  display:flex;
  align-items:center;
  gap:32px;
  list-style:none;
  margin-left:4%;
  margin-right:auto;
}

.tc-nav-links li a{
  text-decoration:none;
  color:#1f2937;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  gap:4px;
  min-width:62px;
  padding:10px 6px;
  font-size:14px;
  font-weight:500;
  border-bottom:3px solid transparent;
  transition:all 0.2s ease;
  cursor:pointer;
}

.tc-nav-links li a span{
  font-size:24px;
  line-height:1;
}

.tc-nav-links li a:hover{
  color:#e91e63;
}

.tc-nav-links li a.active{
  border-bottom:3px solid #e91e63;
  color:#111827;
}

/* Right */
.tc-nav-right{
  display:flex;
  align-items:center;
  gap:15px;
}

/* Wallet */
.tc-wallet{
  display:flex;
  gap:16px;
}

.tc-wallet-item{
  display:flex;
  flex-direction:column;
}

.tc-wallet-item .lbl{
  font-size:11px;
  color:#6b7280;
}

.tc-wallet-item .amt{
  font-size:13px;
  font-weight:600;
  color:#111827;
}

/* Login Button */
.tc-btn-login{
  background:#2e2b78;
  color:#fff;
  border:none;
  outline:none;
  border-radius:28px;
  padding:12px 28px;
  font-size:15px;
  font-weight:500;
  cursor:pointer;
  transition:0.2s;
}

.tc-btn-login:hover{
  background:#1f1b66;
}

/* User */
.tc-user-dropdown{
  position:relative;
  cursor:pointer;
}

.tc-user-icon{
  width:38px;
  height:38px;
  border-radius:50%;
  background:#fff;
  border:1px solid #d1d5db;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:18px;
}

/* Dropdown */
.tc-dropdown-menu{
  position:absolute;
  top:48px;
  right:0;
  width:220px;
  background:#fff;
  border:1px solid #e5e7eb;
  border-radius:10px;
  padding:12px;
  box-shadow:0 10px 25px rgba(0,0,0,0.12);
  z-index:999;
}

.tc-mrow{
  display:block;
  font-size:13px;
  color:#6b7280;
  margin-bottom:4px;
}

.tc-mrow b{
  color:#111827;
}

.tc-mlink{
  display:block;
  padding:9px 0;
  font-size:13px;
  color:#111827;
  text-decoration:none;
  border-top:1px solid #f3f4f6;
  transition:0.2s;
}

.tc-mlink:hover{
  color:#3554d1;
}

/* ── Modal ── */
.tc-modal-overlay{
  position:fixed;
  inset:0;
  background:rgba(0,0,0,0.55);
  display:flex;
  align-items:center;
  justify-content:center;
  z-index:2000;
}

.tc-modal-content{
  position:relative;
  width:100%;
  max-width:420px;
  background:transparent;
  padding:0;
  box-shadow:none;
  border-radius:0;
}
.tc-modal-close{
  position:absolute;
  top:12px;
  right:16px;
  background:none;
  border:none;
  font-size:24px;
  line-height:1;
  cursor:pointer;
  color:#6b7280;
  transition:color 0.2s;
}

.tc-modal-close:hover{
  color:#111827;
}

/* Footer */
.tc-footer{
  background:#1d262d;
  margin-top:40px;
  padding:40px 25px 0;
}

.tc-footer-grid{
  max-width:1200px;
  margin:auto;
  display:grid;
  grid-template-columns:repeat(4,1fr);
  gap:35px;
}

.tc-ftr-title{
  font-size:12px;
  color:#fff;
  font-weight:600;
  margin-bottom:14px;
  text-transform:uppercase;
}

.tc-ftr-links{
  list-style:none;
}

.tc-ftr-links li{
  margin-bottom:10px;
}

.tc-ftr-links a{
  text-decoration:none;
  color:#abb4b9;
  font-size:13px;
}

.tc-ftr-links a:hover{
  color:#fff;
}

.tc-ftr-social{
  display:flex;
  gap:10px;
  list-style:none;
  margin-bottom:22px;
}

.tc-ftr-social a{
  width:35px;
  height:35px;
  border-radius:50%;
  border:1px solid #4b5563;
  display:flex;
  align-items:center;
  justify-content:center;
  text-decoration:none;
  color:#fff;
}

.tc-payment-img{
  width:160px;
}

.tc-copyright{
  max-width:1200px;
  margin:25px auto 0;
  border-top:1px solid #374151;
  padding:16px 0;
  display:flex;
  justify-content:space-between;
  align-items:center;
}

.tc-copyright span{
  color:#9ca3af;
  font-size:12px;
}

.tc-copyright a{
  color:#fff;
  text-decoration:none;
}

/* Responsive */
@media(max-width:768px){
  .tc-nav{
    padding:0 15px;
  }
  .tc-nav-links{
    gap:16px;
  }
  .tc-nav-links li a{
    font-size:12px;
  }
  .tc-nav-links li a span{
    font-size:20px;
  }
  .tc-wallet{
    display:none;
  }
  .tc-footer-grid{
    grid-template-columns:repeat(2,1fr);
  }
  .tc-btn-login{
    padding:10px 18px;
    font-size:13px;
  }
}
`;

// Nav items with routes
const navItems = [
  { label: "Flights", icon: "✈️", tab: "flight", route: "/" },
  { label: "Hotels", icon: "🏨", tab: "hotel", route: "/hotel" },
];

function Header({
  userSession,
  isB2b,
  crBalance,
  crLimit,
  activeTab,
  setActiveTab,
  setOpenLoginModal,
  onLogout
}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (!dropdownOpen) return;
    const close = () => setDropdownOpen(false);
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [dropdownOpen]);

  const handleLogout = () => {
  if (typeof onLogout === "function") {
    onLogout();
  }

  navigate("/");
};

  // Handle tab click with navigation
  const handleTabClick = (item) => {
    console.log(`🔄 Tab clicked: ${item.label} → ${item.route}`);
    setActiveTab(item.tab);
    navigate(item.route);
  };

  return (
    <nav className="tc-nav noPrint">

      {/* Logo */}
      <div className="tc-brand">
        <a href="/">
          <img
            src="/logo.svg"
            alt="TripDilSe"
              style={{ width: 280 }}
          />
        </a>
      </div>

      {/* Center Menu */}
      <ul className="tc-nav-links">
        {navItems.map((item) => (
          <li key={item.tab}>
            <a
              href="#"
              className={activeTab === item.tab ? "active" : ""}
              onClick={(e) => {
                e.preventDefault();
                handleTabClick(item);
              }}
            >
              <span>{item.icon}</span>
              <small>{item.label}</small>
            </a>
          </li>
        ))}
      </ul>

      {/* Right Side */}
      <div className="tc-nav-right">
        {userSession ? (
          <>
            {/* Wallet — only B2B */}
            {isB2b && (
              <div className="tc-wallet">
                <div className="tc-wallet-item">
                  <span className="lbl">Credit Balance</span>
                  <span className="amt">₹{crBalance ?? "—"}</span>
                </div>
                <div className="tc-wallet-item">
                  <span className="lbl">Credit Limit</span>
                  <span className="amt">₹{crLimit ?? "—"}</span>
                </div>
              </div>
            )}

            {/* User dropdown */}
            <div
              className="tc-user-dropdown"
              onClick={(e) => {
                e.stopPropagation();
                setDropdownOpen((prev) => !prev);
              }}
            >
              <div className="tc-user-icon">👤</div>

              {dropdownOpen && (
                <div className="tc-dropdown-menu">
                  <span className="tc-mrow">
                    Hi, <b>{userSession.UserName}</b>
                  </span>
                  <span className="tc-mrow">{userSession.UserEmail}</span>
                  <span className="tc-mrow">{userSession.UserMobile}</span>

                  <a className="tc-mlink" href="/myprofile">My Profile</a>
                  <a className="tc-mlink" href="/flightbookings">My Booking</a>
                 
                  <a
                    className="tc-mlink"
                    href="#"
                    onClick={(e) => { e.preventDefault(); handleLogout(); }}
                    style={{ color: "#dc2626" }}
                  >
                    Logout
                  </a>
                </div>
              )}
            </div>
          </>
        ) : (
          <button
            className="tc-btn-login"
            onClick={() => setOpenLoginModal(true)}
          >
            Login / Register
          </button>
        )}
      </div>
    </nav>
  );
}

// ─────────────────────────────────────────────────────────────
// FOOTER
// ─────────────────────────────────────────────────────────────
function Footer({ isB2b }) {
  return (
    <footer className="tc-footer noPrint">
      <div className="tc-footer-grid">

        {/* Company */}
        <div>
          <p className="tc-ftr-title">Company</p>
          <ul className="tc-ftr-links">
            <li><a href="/about-us">About Us</a></li>
            <li><a href="https://blog.tripcaliber.com/" target="_blank" rel="noreferrer">Blog</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
            <li><a href="/terms">Terms of Use</a></li>
            <li><a href="/refund-policy">Refund Policy</a></li>
          </ul>
        </div>

        {/* Services */}
        <div>
          <p className="tc-ftr-title">Services</p>
          <ul className="tc-ftr-links">
            <li><a href="/">Flight Booking</a></li>
            <li><a href="/hotel">Hotel Booking</a></li>
          </ul>
        </div>

        {/* Help */}
        <div>
          <p className="tc-ftr-title">Help & Support</p>
          <ul className="tc-ftr-links">
            <li><a href="/contact">Contact Us</a></li>
            {!isB2b && (
              <li>
                {/* <a
                  href=""
                  className="tc-btn-login"
                  style={{ display: "inline-block", marginTop: "5px" }}
                >
                  Agent Login
                </a> */}
              </li>
            )}
          </ul>
        </div>

        {/* Social */}
        <div>
          <p className="tc-ftr-title">Keep in Touch</p>
          <ul className="tc-ftr-social">
            <li><a href="#">f</a></li>
            <li><a href="#">𝕏</a></li>
            <li><a href="#">P</a></li>
            <li><a href="#">in</a></li>
            <li><a href="#">▶</a></li>
          </ul>
          {/* <p className="tc-ftr-title">Payment Accepted</p>
          <img
            src="/Content/Images/payment-option.png"
            alt="payment"
            className="tc-payment-img"
          /> */}
        </div>

      </div>

      {/* Copyright */}
      <div className="tc-copyright">
        <span>© 2025 - 2026 TripCaliber</span>
        <span>
          Powered By{" "}
          <a href="https://namantechnolab.com/" target="_blank" rel="noreferrer">
            Naman Technolab
          </a>
        </span>
      </div>
    </footer>
  );
}

// ─────────────────────────────────────────────────────────────
// MAIN LAYOUT
// ─────────────────────────────────────────────────────────────
export default function Layout({
  children,
  userSession: externalUserSession,
  isB2b,
  crBalance,
  crLimit,
  activeTab,
  setActiveTab,
}) {
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const [currentUser, setCurrentUser] = useState(externalUserSession || null);

  // LocalStorage se session load karo (only once on mount)
  useEffect(() => {
    if (!currentUser) {
      try {
        const savedUser = localStorage.getItem("activeUserSession");
        if (savedUser) setCurrentUser(JSON.parse(savedUser));
      } catch {
        localStorage.removeItem("activeUserSession");
      }
    }
  }, []);

  // Agar parent se userSession aaye toh sync karo
  useEffect(() => {
    if (externalUserSession) {
      setCurrentUser(externalUserSession);
    }
  }, [externalUserSession]);

  // Login success handler
  const handleLoginSuccess = (data) => {
    setOpenLoginModal(false);
    setCurrentUser(data);
    localStorage.setItem("activeUserSession", JSON.stringify(data));
  };

  // Local logout — page reload nahi, sirf state clear
  const handleLocalLogout = () => {
    setCurrentUser(null);
    localStorage.removeItem("activeUserSession");
    localStorage.removeItem("userKey");
    localStorage.removeItem("userData");
  localStorage.removeItem("keepLoggedIn"); 

    const logoutUrl = isB2b ? "Index" : "Index";
    fetch(logoutUrl, { method: "GET", credentials: "include" }).catch(() => {});
  };

  return (
    <>
      <style>{styles}</style>

      <Header
        userSession={currentUser}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        isB2b={isB2b}
        crBalance={crBalance}
        crLimit={crLimit}
        setOpenLoginModal={setOpenLoginModal}
         onLogout={handleLocalLogout}
      />

      {/* Main Content */}
      <main>
        {children ? children : null}
      </main>

      <Footer isB2b={isB2b} />

      {/* Login Modal */}
   {openLoginModal && (
  <div
    className="tc-modal-overlay"
    onClick={() => setOpenLoginModal(false)}
  >
    <div
      className="tc-modal-content"
      onClick={(e) => e.stopPropagation()}
    >
      <AuthPage
        onLoginSuccess={handleLoginSuccess}
        onClose={() => setOpenLoginModal(false)}
      />
    </div>
  </div>
)}
    </>
  );
}